import React, {useEffect, useRef} from "react";
import PropTypes from "prop-types";

const ensureScript = (src, id) =>
  new Promise((resolve, reject) => {
	  const existing = document.getElementById(id);
	  if (existing) return resolve(existing);

	  const s = document.createElement("script");
	  s.id = id;
	  s.src = src;
	  s.async = true;
	  s.onload = () => resolve(s);
	  s.onerror = reject;
	  document.body.appendChild(s);
  });

const WistiaEmbed = ({hashedId, embedOptions}) => {
	const containerRef = useRef(null);
	const videoRef = useRef(null);

	useEffect(() => {
		let cancelled = false;

		if (containerRef.current) containerRef.current.innerHTML = "";

		window._wq = window._wq || [];
		window._wq.push({
			id: hashedId,
			onReady: (video) => {
				if (cancelled) return;
				videoRef.current = video;
			},
		});

		(async () => {
			try {
				await ensureScript(
				  `https://fast.wistia.com/embed/medias/${hashedId}.jsonp`,
				  `wistia-jsonp-${hashedId}`
				);
				await ensureScript(
				  "https://fast.wistia.com/assets/external/E-v1.js",
				  "wistia-e-v1"
				);

				if (!cancelled && window.Wistia?.embeds?.setup) {
					window.Wistia.embeds.setup();
				}
			} catch (e) {
				console.error("Wistia scripts failed:", e);
			}
		})();

		return () => {
			cancelled = true;

			if (videoRef.current?.remove) {
				try {
					videoRef.current.remove();
				} catch (_) {
				}
			}
			videoRef.current = null;

			if (containerRef.current) {
				containerRef.current.innerHTML = "";
			}
		};
	}, [hashedId]);

	const optionsStr = embedOptions
	  ? Object.entries(embedOptions)
		.map(([k, v]) => `${k}=${String(v)}`)
		.join(" ")
	  : "";

	return (
	  <div
		ref={containerRef}
		className={`wistia_embed wistia_async_${hashedId} ${optionsStr}`.trim()}
		style={{width: "100%", aspectRatio: "16 / 9"}}
	  />
	);
};

WistiaEmbed.propTypes = {
	hashedId: PropTypes.string.isRequired,
	embedOptions: PropTypes.object,
};

export default WistiaEmbed;